<template>
<div id="navigation" :class="{'drop-shadow': show_mini_cart}">
    <div class="container">
        <nav class="navbar is-transparent">
            <div class="navbar-brand">
                <div ref="catalog_menu" class="navbar-item has-dropdown is-hoverable catalog-menu" v-if="catalog">
                    <router-link class="navbar-link is-arrowless" :to="catalog.url">
                        <i class="fas fa-bars"></i>
                        {{catalog.label}}
                    </router-link>
                    <div class="navbar-dropdown" v-if="!catalog_disabled">
                        <router-link class="navbar-item" :to="item.url" v-for="item, i in catalog.sub" :key="i">{{item.label}}</router-link>
                    </div>
                </div>
                <div v-on:click="show_mobile_menu" :class="{'navbar-burger': true, 'burger': true, 'is-active': mobile_menu_is_active}" data-target="mobile-menu">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            <div id="mobile-menu" :class="{'navbar-menu': true, 'is-active': mobile_menu_is_active}">
                <div class="navbar-end">
                    <router-link class="navbar-item" v-for="item, i in navigation" v-if="i > 0" :to="item.url" :key="i">{{item.label}}</router-link>
                    <div :class="['navbar-item mini-cart-holder', {'show': show_mini_cart}]">
                        <MiniCart class="mini" :mini="true" />
                    </div>
                </div>
            </div>
        </nav>
    </div>
</div>
</template>
<script>
import MiniCart from './elements/MiniCart';
export default {
    name: 'Navigation',
    props: ['site_data'],
    components: { MiniCart },
    data: function() {
        return {
            catalog_disabled: this.$store.state.site_data.pagetype == 'Catalog' ? true : false,
            show_mini_cart: false,
            mobile_menu_is_active: false,
            navigation: this.$store.state.site_data.navigation
        }
    },
    mounted()
    {
        this.$bus.$on('onToggleMenu', this.menu_change_handler);
        this.$nextTick().then(() => {
            let catalog =   $(this.$refs.catalog_menu),
                me      =   this;
            if (catalog.length > 0) {
                catalog.on('mousemove', this.en_catalog).on('mouseleave', this.en_catalog);
                catalog.on('click', function(e) {
                    me.catalog_disabled =   false;
                });
            }
            $(this.$el).on('mouseenter', this.en_catalog);
        });
    },
    beforeDestory()
    {
        this.$bus.$off('onToggleMenu', this.menu_change_handler);
    },
    computed: {
        catalog()
        {
            if (this.$store.state.site_data && this.$store.state.site_data.navigation) {
                return this.$store.state.site_data.navigation.find(o => o.pagetype == 'Catalog');
            }
            return null;
        }
    },
    methods: {
        en_catalog(e)
        {
            if (!$(this.$refs.catalog_menu).is(':hover')) {
                this.catalog_disabled   =   false;
            }
        },
        menu_change_handler(is_collapsed)
        {
            this.show_mini_cart =   is_collapsed;
        },
        click_to_close: function(e) {
            let target = $(e.target);
            if (!target.is('.burger') &&
                target.parents('.burger').length == 0 &&
                !target.is('.navbar-item') &&
                target.parents('.navbar-item').length == 0) {

                this.mobile_menu_is_active = false;
                $(window).unbind('mousedown', this.click_to_close);
            }
        },
        show_mobile_menu: function(e) {
            e.preventDefault();
            $(window).unbind('mousedown', this.click_to_close).on('mousedown', this.click_to_close);
            this.mobile_menu_is_active = !this.mobile_menu_is_active;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/Navigation.vue